import ShopifyApiError from './ShopifyApiError';

const OPAQUE_MESSAGE = 'Sorry, something went wrong. Please try again.';

const shopifyErrors = {
  422: {
    type: 'cart',
    useErrorMessage: true,
    getError: async (res) => {
      const data = await res.json();
      throw new ShopifyApiError(data.description);
    },
  },
  400: {
    type: 'cart',
    useErrorMessage: false,
  },
  404: {
    type: 'cart',
    useErrorMessage: false,
  },
};

async function customErrorHandler(res) {
  const handler = shopifyErrors[res.status];
  if (!handler) return;
  if (handler.useErrorMessage) {
    await handler.getError(res);
  } else {
    throw new ShopifyApiError(OPAQUE_MESSAGE);
  }
}

export default customErrorHandler;
